import { localizedProviderTitleId } from '../../modules/core';

export const USER_TITLE_OTHER = 'Other';

export default angular
  .module('doxy.global.models.user', [])
  .service('UserMethods', function ($translate) {
    return {
      isNull() {
        return !Boolean(this.id);
      },

      /**
       * @param {boolean} isV2
       */
      getDisplayName(isV2 = false) {
        if (this.isNull()) {
          return;
        }
        if (Boolean(this.displayName)) {
          // eslint-disable-next-line consistent-return
          return this.displayName;
        }
        const hasTitle = Boolean(this.title) && this.title !== USER_TITLE_OTHER;
        const providerName = isV2
          ? `${this.firstName} ${this.lastName}`
          : `${this.lastName}`;

        // eslint-disable-next-line consistent-return
        return hasTitle
          ? `${$translate.instant(localizedProviderTitleId(this.title))} ${
              this.lastName
            }`
          : providerName;
      },

      hasDayPass() {
        if (!this.dayPassEndDate) return false;
        return new Date(this.dayPassEndDate).getTime() > new Date().getTime();
      },

      isUpgraded() {
        return (
          this.institutionMember ||
          this.activePurchase ||
          this.trialEndDate ||
          this.hasDayPass()
        );
      },

      hasSuperAdminRights() {
        return (
          this.capabilities &&
          this.capabilities.some((item) => item.capability === 'master_access')
        );
      },
    };
  }).name;
